<template lang="html">
		<v-sheet class="w-100 h-100 d-flex justify-center align-center" color="transparent">
			<v-btn @click="btnClickedHandler()" :color="value ? 'success' : 'error'" small icon>
				<v-icon>{{ value ? 'mdi-check' : 'mdi-close' }}</v-icon>
			</v-btn>
		</v-sheet>
</template>
<script>
  export default {
    name: 'ModelMatchRenderer',
    data() {
      return {};
    },
    methods: {
      btnClickedHandler() {
        if (!this.params.clicked) return;

        this.params.clicked(this.params.data);
      },
    },
    computed: {
      value() {
        return this.params.value;
      },
    },
  };
</script>
<style lang="css"></style>
